{
    "8aa56548-57e2-40f6-a043-a7672366addd": {
        "affiliation": "none",
        "key": "8aa56548-57e2-40f6-a043-a7672366addd",
        "position": {
            "x": 7,
            "y": 7,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "cf17e082-62ca-46bc-a04a-c6b34e76b8f5": {
        "affiliation": "none",
        "key": "cf17e082-62ca-46bc-a04a-c6b34e76b8f5",
        "position": {
            "x": 6,
            "y": 7,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "b2aebb8e-5ab4-403b-b1ed-ae567e188e1b": {
        "affiliation": "none",
        "key": "b2aebb8e-5ab4-403b-b1ed-ae567e188e1b",
        "position": {
            "x": 6,
            "y": 6,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "60360fb7-b8c5-414e-858a-6e070bd3f46e": {
        "affiliation": "none",
        "key": "60360fb7-b8c5-414e-858a-6e070bd3f46e",
        "position": {
            "x": 8,
            "y": 6,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "582f8054-6877-46b3-82d4-18451422e78f": {
        "affiliation": "none",
        "key": "582f8054-6877-46b3-82d4-18451422e78f",
        "position": {
            "x": 7,
            "y": 5,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "4eb4e904-61b5-4d88-819b-e707d7eea986": {
        "affiliation": "bad",
        "key": "4eb4e904-61b5-4d88-819b-e707d7eea986",
        "position": {
            "x": 5,
            "y": 3,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "sword",
        "templateKey": "jobs/sword"
    },
    "cf05d3f0-9f1a-441a-a46b-8fd765ac883c": {
        "affiliation": "bad",
        "key": "cf05d3f0-9f1a-441a-a46b-8fd765ac883c",
        "position": {
            "x": 4,
            "y": 4,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "mage",
        "templateKey": "jobs/mage"
    },
    "100c2f8c-89df-4eb7-8415-11bd968b921f": {
        "affiliation": "bad",
        "key": "100c2f8c-89df-4eb7-8415-11bd968b921f",
        "position": {
            "x": 4,
            "y": 2,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "spearcavalier",
        "templateKey": "jobs/spearcavalier"
    },
    "49ebb10b-2354-4974-9872-433f648f10c1": {
        "affiliation": "bad",
        "key": "49ebb10b-2354-4974-9872-433f648f10c1",
        "position": {
            "x": 2,
            "y": 2,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "swordcavalier",
        "templateKey": "jobs/swordcavalier"
    },
    "49fa1cd3-0f37-4457-bd4a-0bdb4e750433": {
        "affiliation": "bad",
        "key": "49fa1cd3-0f37-4457-bd4a-0bdb4e750433",
        "position": {
            "x": 4,
            "y": 8,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "hammercavalier",
        "templateKey": "jobs/hammercavalier"
    },
    "e0b33b9f-fc1b-4a03-ab74-fe39c2a1cbec": {
        "affiliation": "bad",
        "key": "e0b33b9f-fc1b-4a03-ab74-fe39c2a1cbec",
        "position": {
            "x": 7,
            "y": 8,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "gun",
        "templateKey": "jobs/gun"
    },
    "3e94cc18-bbfc-400c-9461-472288802114": {
        "affiliation": "bad",
        "key": "3e94cc18-bbfc-400c-9461-472288802114",
        "position": {
            "x": 5,
            "y": 8,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "spear",
        "templateKey": "jobs/spear"
    },
    "5da3ffc7-d01f-4f45-8226-5df33ab940d5": {
        "affiliation": "bad",
        "key": "5da3ffc7-d01f-4f45-8226-5df33ab940d5",
        "position": {
            "x": 6,
            "y": 9,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "hammer",
        "templateKey": "jobs/hammer"
    },
    "8a3e3d88-7749-4981-afb0-31e5884232be": {
        "affiliation": "bad",
        "key": "8a3e3d88-7749-4981-afb0-31e5884232be",
        "position": {
            "x": 11,
            "y": 6,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "bow",
        "templateKey": "jobs/bow"
    },
    "68373125-56ba-438f-b988-ca11f860471b": {
        "affiliation": "bad",
        "key": "68373125-56ba-438f-b988-ca11f860471b",
        "position": {
            "x": 9,
            "y": 9,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "spear",
        "templateKey": "jobs/spear"
    },
    "4c77ea23-c821-4012-90f7-9c321f669dce": {
        "affiliation": "bad",
        "key": "4c77ea23-c821-4012-90f7-9c321f669dce",
        "position": {
            "x": 11,
            "y": 8,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "spearcavalier",
        "templateKey": "jobs/spearknight"
    },
    "07e22151-5056-47e0-b348-b23bb9590836": {
        "affiliation": "bad",
        "key": "07e22151-5056-47e0-b348-b23bb9590836",
        "position": {
            "x": 13,
            "y": 10,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "swordcavalier",
        "templateKey": "jobs/swordcavalier"
    },
    "605ad2b0-6b36-4ccd-8391-5710d8cde3f3": {
        "affiliation": "bad",
        "key": "605ad2b0-6b36-4ccd-8391-5710d8cde3f3",
        "position": {
            "x": 11,
            "y": 25,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "mage",
        "templateKey": "jobs/mage"
    },
    "39ceb5e6-d469-44ff-a4ef-790e3f909683": {
        "affiliation": "none",
        "key": "39ceb5e6-d469-44ff-a4ef-790e3f909683",
        "position": {
            "x": 4,
            "y": 23,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "30c5651a-8634-48ea-a9bb-1aebae7e0684": {
        "affiliation": "none",
        "key": "30c5651a-8634-48ea-a9bb-1aebae7e0684",
        "position": {
            "x": 3,
            "y": 22,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "cea68c0a-750f-476c-895a-469044dc356b": {
        "affiliation": "none",
        "key": "cea68c0a-750f-476c-895a-469044dc356b",
        "position": {
            "x": 3,
            "y": 23,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "bffb60de-2667-4a84-bcaa-f04e24af7cbc": {
        "affiliation": "none",
        "key": "bffb60de-2667-4a84-bcaa-f04e24af7cbc",
        "position": {
            "x": 4,
            "y": 22,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "5165cb3d-729e-47c3-9345-faeaef393c58": {
        "affiliation": "none",
        "key": "5165cb3d-729e-47c3-9345-faeaef393c58",
        "position": {
            "x": 3,
            "y": 24,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "f5b8023a-6560-4ec3-81da-506a716c5c9e": {
        "affiliation": "bad",
        "key": "f5b8023a-6560-4ec3-81da-506a716c5c9e",
        "position": {
            "x": 5,
            "y": 20,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "templateKey": "randoms/advanced"
    },
    "9a789f1c-ca0d-4912-a801-eb39a8029724": {
        "affiliation": "bad",
        "key": "9a789f1c-ca0d-4912-a801-eb39a8029724",
        "position": {
            "x": 9,
            "y": 19,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "templateKey": "randoms/advanced"
    },
    "c9739ed9-76cb-401a-9d81-53619741bb8e": {
        "affiliation": "bad",
        "key": "c9739ed9-76cb-401a-9d81-53619741bb8e",
        "position": {
            "x": 10,
            "y": 26,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "templateKey": "randoms/advanced"
    },
    "8be52257-e281-4a42-afbd-b25f5d150338": {
        "affiliation": "bad",
        "key": "8be52257-e281-4a42-afbd-b25f5d150338",
        "position": {
            "x": 13,
            "y": 24,
            "z": 1
        },
        "level": 1,
        "faceKey": "boar",
        "randomJobKey": "hammercavalier",
        "templateKey": "randoms/advanced",
        "maxhealth": "20"
    },
    "fbcebccb-9024-4251-bd13-c1589ff48ad4": {
        "affiliation": "bad",
        "key": "fbcebccb-9024-4251-bd13-c1589ff48ad4",
        "position": {
            "x": 6,
            "y": 24,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "spearknight",
        "templateKey": "jobs/spearknight"
    },
    "768cfb4d-69aa-4ff3-ac1c-29767a9b513f": {
        "affiliation": "bad",
        "key": "768cfb4d-69aa-4ff3-ac1c-29767a9b513f",
        "position": {
            "x": 5,
            "y": 25,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "swordknight",
        "templateKey": "jobs/swordknight"
    },
    "fca44fda-f681-4696-a95c-675c4604ef11": {
        "affiliation": "bad",
        "key": "fca44fda-f681-4696-a95c-675c4604ef11",
        "position": {
            "x": 8,
            "y": 25,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "spear",
        "templateKey": "jobs/spear"
    },
    "525c1ad3-7740-429b-8bd4-69c124c85d32": {
        "affiliation": "bad",
        "key": "525c1ad3-7740-429b-8bd4-69c124c85d32",
        "position": {
            "x": 9,
            "y": 24,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "swordknight",
        "templateKey": "jobs/swordknight"
    },
    "b2d46742-7d1c-4101-9e93-0341737ec09f": {
        "affiliation": "bad",
        "key": "b2d46742-7d1c-4101-9e93-0341737ec09f",
        "position": {
            "x": 9,
            "y": 23,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "spearcavalier",
        "templateKey": "jobs/spearcavalier"
    },
    "7ad5466f-7c2d-4862-9fbe-7183c50f97c1": {
        "affiliation": "bad",
        "key": "7ad5466f-7c2d-4862-9fbe-7183c50f97c1",
        "position": {
            "x": 8,
            "y": 21,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "swordcavalier",
        "templateKey": "jobs/swordcavalier"
    },
    "eeff8090-80b3-41d7-b77a-3302afeccf73": {
        "affiliation": "bad",
        "key": "eeff8090-80b3-41d7-b77a-3302afeccf73",
        "position": {
            "x": 6,
            "y": 23,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "bow",
        "templateKey": "jobs/bow"
    },
    "cc46e42c-6a46-448e-a5f4-523d8de820f1": {
        "affiliation": "bad",
        "key": "cc46e42c-6a46-448e-a5f4-523d8de820f1",
        "position": {
            "x": 10,
            "y": 20,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "bow",
        "templateKey": "jobs/bow"
    },
    "9ab2de5a-7add-4fd5-a972-bdedf29f3c79": {
        "affiliation": "bad",
        "key": "9ab2de5a-7add-4fd5-a972-bdedf29f3c79",
        "position": {
            "x": 12,
            "y": 22,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "hammercavalier",
        "templateKey": "jobs/hammercavalier"
    },
    "77476e28-6b4d-4f24-8e7b-347d6e329c48": {
        "affiliation": "bad",
        "key": "77476e28-6b4d-4f24-8e7b-347d6e329c48",
        "position": {
            "x": 6,
            "y": 22,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "spear",
        "templateKey": "jobs/spear"
    },
    "8c55059d-e176-4223-b812-8a1406d3baf9": {
        "affiliation": "bad",
        "key": "8c55059d-e176-4223-b812-8a1406d3baf9",
        "position": {
            "x": "16",
            "y": 40,
            "z": 1
        },
        "level": 1,
        "faceKey": "devil",
        "jobKey": "arcanecavalier",
        "templateKey": "jobs/arcanecavalier",
        "maxhealth": "30"
    },
    "00bfde51-23a8-4bea-8edd-044e8bfbd0b7": {
        "affiliation": "none",
        "key": "00bfde51-23a8-4bea-8edd-044e8bfbd0b7",
        "position": {
            "x": 12,
            "y": 37,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "da327d76-eecc-4495-ab82-a7534e931201": {
        "affiliation": "none",
        "key": "da327d76-eecc-4495-ab82-a7534e931201",
        "position": {
            "x": 11,
            "y": 37,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "f2fe155d-1cb7-4f7b-942b-fd291e46484e": {
        "affiliation": "none",
        "key": "f2fe155d-1cb7-4f7b-942b-fd291e46484e",
        "position": {
            "x": 10,
            "y": 37,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "21237423-d98c-498b-b52b-f51dc5ddaba8": {
        "affiliation": "none",
        "key": "21237423-d98c-498b-b52b-f51dc5ddaba8",
        "position": {
            "x": 12,
            "y": 36,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "354b4d7c-008b-40a3-8a22-b93dffa43dce": {
        "affiliation": "none",
        "key": "354b4d7c-008b-40a3-8a22-b93dffa43dce",
        "position": {
            "x": 12,
            "y": 35,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "type": "zone",
        "templateKey": "spawnspot"
    },
    "9ce7fe73-a845-4d95-893e-7124e5b771af": {
        "affiliation": "bad",
        "key": "9ce7fe73-a845-4d95-893e-7124e5b771af",
        "position": {
            "x": 13,
            "y": 39,
            "z": 1
        },
        "level": 1,
        "faceKey": "imp",
        "jobKey": "hammer",
        "templateKey": "jobs/hammer"
    },
    "60475fc3-c6da-4f66-aa2a-62ce8131051d": {
        "affiliation": "bad",
        "key": "60475fc3-c6da-4f66-aa2a-62ce8131051d",
        "position": {
            "x": 14,
            "y": 38,
            "z": 1
        },
        "level": 1,
        "faceKey": "imp",
        "jobKey": "hammer",
        "templateKey": "jobs/hammer"
    },
    "fe13cf9f-2f22-4930-a9cd-ead2118d95d9": {
        "affiliation": "bad",
        "key": "fe13cf9f-2f22-4930-a9cd-ead2118d95d9",
        "position": {
            "x": 15,
            "y": 36,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "mage",
        "templateKey": "jobs/mage"
    },
    "18f94ade-a10a-4448-88c3-795dceeba623": {
        "affiliation": "bad",
        "key": "18f94ade-a10a-4448-88c3-795dceeba623",
        "position": {
            "x": 11,
            "y": 40,
            "z": 1
        },
        "level": 1,
        "faceKey": "wolf",
        "jobKey": "mage",
        "templateKey": "jobs/mage"
    }
}
